import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './owlet-response.css';

/** Allow ordinary web, email and in-app links; never execute model-provided URLs. */
export function safeAssistantHref(value: string): string {
  const href = value.trim();
  if (/[\u0000-\u0020\u007f]/.test(href) || href.includes('\\')) return '';
  if (/^https?:\/\//i.test(href) || /^mailto:/i.test(href)) return href;
  if ((href.startsWith('/') && !href.startsWith('//')) || href.startsWith('#')) return href;
  return '';
}

export function OwletResponseContent({ content, role = 'assistant' }: { content: string; role?: 'user' | 'assistant' }) {
  if (role === 'user') return <div className="owlet-user-text">{content}</div>;

  return (
    <div className="owlet-response">
      <ReactMarkdown
        skipHtml
        remarkPlugins={[remarkGfm]}
        urlTransform={safeAssistantHref}
        components={{
          a: ({ href, title, children }) => href ? (
            <a href={href} title={title} target={/^https?:\/\//i.test(href) ? '_blank' : undefined} rel="noopener noreferrer">{children}</a>
          ) : <span>{children}</span>,
          pre: ({ children }) => <pre tabIndex={0} role="region" aria-label="Code block">{children}</pre>,
          table: ({ children }) => (
            <div className="owlet-table-scroll" tabIndex={0} role="region" aria-label="Response table. Scroll horizontally to see all columns.">
              <table>{children}</table>
            </div>
          ),
          th: ({ children, style }) => <th scope="col" style={style}>{children}</th>,
          // Answers do not need remote images, which could also leak a reader's IP.
          img: ({ alt }) => <span className="owlet-image-label">[Image omitted{alt ? `: ${alt}` : ''}]</span>,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
